import { takeLatest, call, put, all } from 'redux-saga/effects';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';
import { Login } from 'store/modules/api/sgu/loginUnico/types';

import { IFormCadastroRg } from 'pages/iirgd/RgFicDigital/CadastroRg/form';

// SERVICES
import { ApiResponse, postApi, putApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { treatRequest } from 'utils/functions/treatRequest';
import { addNotifications } from 'store/modules/app/notifications/actions';
import { MultifiliacaoRg, Types } from './types';

// ACTIONS
import {
	cadastroRgPrincipal,
	cadastroRgConfigEdicao,
	cadastrarRgSuccess,
	cadastrarRgFailure,
	atualizarRgSuccess,
	cadastroRgSegundaVia,
	atualizarLote,
	atualizarRgFailure,
	cadastroRgMultifiliacao,
	atualizarRgMultifiliacao,
} from './actions';

// UTILS
import { formatarAtualizarCITA, formatarCadastrarRG } from './functions';
import { IConsultaPesquisaCidadaoSelecionado } from '../consultaPesquisaCidadao/types';

function* cadastrarRgRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: any } = request;
	const {
		formValues,
		login,
	}: {
		formValues: IFormCadastroRg;
		login: Login;
	} = payload;

	const usuario = {
		usuario: login.mainframe.idUsuario,
		senha: login.mainframe.senhaMainFrame,
	};

	const requestValues = formatarCadastrarRG(formValues, login);

	delete requestValues.inscricaoCpf;
	delete requestValues.cpfAtendente;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'rg',
		treatRequest(requestValues),
		usuario,
	);

	if (
		(response.status === 200 || response.status === 201) &&
		response.data?.numeroRg &&
		(response.data?.statusMultifiliacao === 200 ||
			response.data?.statusMultifiliacao === 201)
	) {
		formValues.numeroRg = response.data.numeroRg;
		formValues.sedex = response.data.sedex;
		const body = { ...formValues };
		const {
			statusAbrevManual = false,
			statusMultifiliacao,
			msgMultifiliacao = '',
		}: MultifiliacaoRg = response.data;

		yield put(
			cadastroRgMultifiliacao({
				statusAbrevManual,
				statusMultifiliacao,
				msgMultifiliacao,
			}),
		);
		yield put(cadastroRgPrincipal(null, body, null));
		yield put(atualizarLote(response?.data?.lote));
		yield put(cadastroRgConfigEdicao());
		yield put(cadastrarRgSuccess(true));
	} else if (response?.numeroRg || response?.data?.numeroRg) {
		if (response.data.msgMultifiliacao) {
			addNotifications({
				errors: [response.data.msgMultifiliacao],
			});
		}
		formValues.numeroRg = response.numeroRg || response.data.numeroRg;
		yield put(cadastroRgPrincipal(null, formValues, null));
	} else {
		if (response.data?.msgMultifiliacao) {
			addNotifications({
				errors: [response.data.msgMultifiliacao],
			});
		}
		yield put(cadastrarRgFailure(response.data.data.numeroRg));
	}
}

function* atualizarRgRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: any } = request;
	const {
		original,
		formValues,
		login,
		isPrimeiraVia,
		consultaPesquisaCidadaoSelecionado,
	}: {
		original: IFormCadastroRg;
		formValues: IFormCadastroRg;
		login: Login;
		isPrimeiraVia: boolean;
		consultaPesquisaCidadaoSelecionado: IConsultaPesquisaCidadaoSelecionado | null;
	} = payload;

	const usuario = {
		usuario: login.mainframe.idUsuario,
		senha: login.mainframe.senhaMainFrame,
	};

	const requestValues = formatarAtualizarCITA(formValues, login);

	delete requestValues.inscricaoCpf;
	delete requestValues.cpfAtendente;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'rg',
		treatRequest(requestValues),
		usuario,
	);

	if (
		response.status === 200 &&
		(response.data?.statusMultifiliacao === 200 ||
			response.data?.statusMultifiliacao === 201)
	) {
		const {
			statusAbrevManual = false,
			statusMultifiliacao,
			msgMultifiliacao = '',
		}: MultifiliacaoRg = response.data;

		if (
			isPrimeiraVia &&
			response.data.lote !== '' &&
			response.data.lote.indexOf('2') !== -1
		) {
			yield put(cadastroRgSegundaVia());
		}
		yield put(atualizarLote(response.data.lote));

		yield put(
			cadastroRgPrincipal(
				original,
				{
					...formValues,
					sedex: response?.data?.sedex,
					ufResidencia: requestValues.ufResidencia ?? '',
				},
				consultaPesquisaCidadaoSelecionado,
			),
		);

		yield put(
			atualizarRgMultifiliacao({
				statusAbrevManual,
				statusMultifiliacao,
				msgMultifiliacao,
			}),
		);
		yield put(atualizarRgSuccess(true));
	}

	if (response.data?.msgMultifiliacao) {
		addNotifications({
			errors: [response.data.msgMultifiliacao],
		});
	}

	yield put(atualizarRgFailure());
}

export default all([
	takeLatest(Types.CADASTRAR_RG_REQUEST, cadastrarRgRequest),
	takeLatest(Types.ATUALIZAR_RG_REQUEST, atualizarRgRequest),
]);
